import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import pricingData from '../../../data/pricing-cards.json';

function Price({ serviceType = 'cleaning' }) {
  const serviceData = pricingData.services[serviceType];

  useEffect(() => {
    // Initialize WOW.js if it's being used
    if (typeof window !== 'undefined' && window.WOW) {
      new window.WOW().init();
    }
  }, []);

  if (!serviceData) {
    console.error(`No service data found for ${serviceType}`);
    return null;
  }

  return (
    <section className="price-hr section-padding">
      <div className="container">
        <div className="row">
          <div className="col-lg-5 valign">
            <div className="cont full-width md-mb50">
              <div>
                <h6 className="sub-title main-color mb-15">
                  Over 1,000+ Clients
                </h6>
                {/* Modified heading structure */}
                <div className="titles-wrapper">
                  <h3>
                    <div className="title-line mb-15">
                      {serviceData.title}
                    </div>
                    <div className="title-line">
                      {serviceData.subtitle}
                    </div>
                  </h3>
                </div>
                <div className="text mt-20">
                  <p>{serviceData.description}</p>
                </div>
                <ul className="rest list-arrow mt-30 pt-30 bord-thin-top">
                  <li>
                    <span className="icon">
                      <svg width="100%" height="100%" viewBox="0 0 9 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fillRule="evenodd" clipRule="evenodd" d="M7.71108 3.78684L8.22361 4.29813L7.71263 4.80992L4.64672 7.87832L4.13433 7.36688L6.87531 4.62335H1.11181H0.750039H0.388177L0.382812 0.718232H1.10645L1.11082 3.90005H6.80113L4.12591 1.22972L4.63689 0.718262L7.71108 3.78684Z" fill="#14cf93"></path>
                      </svg>
                    </span>
                    <h6 className="inline fw-400">Expert service for every space.</h6>
                  </li>
                  <li className="mt-10">
                    <span className="icon">
                      <svg width="100%" height="100%" viewBox="0 0 9 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fillRule="evenodd" clipRule="evenodd" d="M7.71108 3.78684L8.22361 4.29813L7.71263 4.80992L4.64672 7.87832L4.13433 7.36688L6.87531 4.62335H1.11181H0.750039H0.388177L0.382812 0.718232H1.10645L1.11082 3.90005H6.80113L4.12591 1.22972L4.63689 0.718262L7.71108 3.78684Z" fill="#14cf93"></path>
                      </svg>
                    </span>
                    <h6 className="inline fw-400">Professional solutions.</h6>
                  </li>
                  <li className="mt-10">
                    <span className="icon">
                      <svg width="100%" height="100%" viewBox="0 0 9 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fillRule="evenodd" clipRule="evenodd" d="M7.71108 3.78684L8.22361 4.29813L7.71263 4.80992L4.64672 7.87832L4.13433 7.36688L6.87531 4.62335H1.11181H0.750039H0.388177L0.382812 0.718232H1.10645L1.11082 3.90005H6.80113L4.12591 1.22972L4.63689 0.718262L7.71108 3.78684Z" fill="#14cf93"></path>
                      </svg>
                    </span>
                    <h6 className="inline fw-400">Quality guaranteed service.</h6>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="col-lg-6 offset-lg-1 valign">
            <div className="full-width">
              {serviceData.pricingCards.map((card) => (
                <div key={card.id} className={card.className}>
                  <div className="type">
                    <div className="icon-img-60 mb-10">
                      <img src={card.icon} alt="" />
                    </div>
                    <h5 className="fw-600">{card.type}</h5>
                  </div>
                  <div className="cont ml-50">
                    <ul className="dot-list rest">
                      {card.features.map((feature, index) => (
                        <li key={index} className={index !== card.features.length - 1 ? "mb-10" : ""}>
                          {feature}
                        </li>
                      ))}
                    </ul>
                  </div>
                  <div className="mount ml-auto text-center">
                    <h5 className="numb-font">
                      <span className="fz-20">₹</span> {card.price}
                    </h5>
                    <div>
                      <as
                        href="/dark/page-contact"
                        className={card.buttonClass}
                      >
                        <span className="fz-13">Contact Us</span>
                      </as>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
Price.propTypes = {
  serviceType: PropTypes.string,
};


export default Price;